module.exports = __webpack_public_path__ + "static/media/05_tn.bd6b12bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/05_tn.jpg
// module id = 641
// module chunks = 0